import { createFilterContext } from '../../../../common/filter/createFilterContext';
import { ALL_SECTION_TYPES, SectionType } from '../../sectionMeta';

type AnalyticsFilterState = {
  selectedLocationIds: string[] | null; // null = all
  selectedOrderPageIds: string[] | null; // null = all
  sectionTypes: SectionType[];
};

const DEFAULTS: AnalyticsFilterState = {
  selectedLocationIds: null,
  selectedOrderPageIds: null,
  sectionTypes: ALL_SECTION_TYPES,
};

const { Provider: AnalyticsFilterProvider, useBaseFilter } = createFilterContext<AnalyticsFilterState>({
  storageKey: 'webook-analytics-filter-v3',
  defaults: DEFAULTS,
  isActive: (s) =>
    s.selectedLocationIds !== null ||
    s.selectedOrderPageIds !== null ||
    s.sectionTypes.length !== ALL_SECTION_TYPES.length,
});

export { AnalyticsFilterProvider };

export const useAnalyticsFilter = () => {
  const { state, setState, isActive, reset } = useBaseFilter();
  return {
    selectedLocationIds: state.selectedLocationIds,
    setSelectedLocationIds: (v: string[] | null) => setState({ selectedLocationIds: v }),
    selectedOrderPageIds: state.selectedOrderPageIds,
    setSelectedOrderPageIds: (v: string[] | null) => setState({ selectedOrderPageIds: v }),
    sectionTypes: state.sectionTypes,
    setSectionTypes: (v: SectionType[]) => setState({ sectionTypes: v }),
    isFilterActive: isActive,
    resetFilter: reset,
  };
};
